import type {
  IChatFolderListObject,
  IChatFolderListResponse,
  ICreateChatFolderPayload,
  IDeleteChatFolderParams,
  IGetChatFolderListParams,
  IUpdateChatFolderPayload,
} from "../types";
import type { ApiClient } from "./client";

export class ChatFolderApi {
  constructor(private readonly apiClient: ApiClient) {}

  async getChatFolderList(
    params: IGetChatFolderListParams,
  ): Promise<IChatFolderListResponse> {
    const { limit, offset } = params;
    const response = await this.apiClient.get<IChatFolderListResponse>(
      `/chat-folders?limit=${limit}&offset=${offset}`,
    );
    return response.data;
  }

  async createChatFolder({
    name,
  }: ICreateChatFolderPayload): Promise<IChatFolderListObject> {
    const response = await this.apiClient.post<IChatFolderListObject>(
      "/chat-folders",
      { name },
    );
    return response.data;
  }

  async updateChatFolder({
    uuid,
    name,
    customInstructions,
  }: IUpdateChatFolderPayload): Promise<IChatFolderListObject> {
    const response = await this.apiClient.post<IChatFolderListObject>(
      `/chat-folders/${uuid}/update`,
      {
        name,
        ...(customInstructions !== undefined && { customInstructions }),
      },
    );
    return response.data;
  }

  async deleteChatFolder({
    uuid,
    moveChatsToRoot,
  }: IDeleteChatFolderParams): Promise<void> {
    await this.apiClient.post(
      `/chat-folders/${uuid}/delete?moveChatsToRoot=${moveChatsToRoot}`,
    );
  }
}
